/* Navigation directement sur la photo de la fiche produit.
   Réutilise les boutons de miniatures existants (product-configurator.js)
   pour les classes actives et la synchronisation avec les variantes. Le zoom
   et le glissement natif continuent d'utiliser leurs propres mécanismes. */
(() => {
  'use strict';
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const navs = Array.from(gallery.querySelectorAll('[data-gallery-step]'));
    if (!track || navs.length !== 2) return;
    const medias = Array.from(track.querySelectorAll('[data-media-id]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-media-target]'));
    if (medias.length < 2 || thumbs.length !== medias.length) return;
    const counter = gallery.querySelector('[data-gallery-index]');
    const etroit = () => window.matchMedia('(max-width: 759px)').matches;

    const visibleIndex = () => {
      if (etroit()) {
        const step = medias.length > 1
          ? medias[1].offsetLeft - medias[0].offsetLeft
          : track.clientWidth;
        if (step > 0 && track.scrollWidth > track.clientWidth + 2) {
          return Math.max(0,Math.min(medias.length - 1,Math.round(track.scrollLeft / step)));
        }
      }
      const selected = medias.findIndex((media) => media.classList.contains('is-active'));
      return selected < 0 ? 0 : selected;
    };

    const aller = (pas) => {
      const index = (visibleIndex() + pas + medias.length) % medias.length;
      const thumb = thumbs.find((button) => button.dataset.mediaTarget === medias[index].dataset.mediaId);
      if (!thumb) return;
      /* Clique sur la miniature au lieu de réimplémenter le configurateur.
         Elle peut être masquée visuellement sur mobile : .click() fonctionne. */
      thumb.click();
      /* Après un balayage, la classe is-active peut être en retard sur la
         position de la piste. Garantir le recentrage même si le gestionnaire
         historique de miniature retourne avant de défiler. */
      if (etroit()) {
        const left = medias[index].offsetLeft - medias[0].offsetLeft;
        track.scrollTo({left:Math.max(0,left),behavior:'auto'});
      }
      if (counter) counter.textContent = String(index + 1);
    };

    for (const nav of navs) {
      const step = Number(nav.dataset.galleryStep);
      if (step !== -1 && step !== 1) continue;
      nav.hidden = false;
      nav.addEventListener('click', () => aller(step));
    }

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input,select,textarea,video')) return;
      const scope = gallery.closest('.shopify-section') || document;
      if (scope.querySelector('[data-gallery-zoom][open]')) return;
      event.preventDefault();
      aller(event.key === 'ArrowLeft' ? -1 : 1);
    });
  });
})();
